import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { IOrderInputTypeEnum } from "@jti/magento";
import { selectOrderAttributesByTarget, useSelector } from "@jti/store";
import { useGetProfile } from "../../hooks/useGetProfile";
import { OrderAttributeCheckbox } from "./OrderAttributeCheckbox";
import { OrderAttributeTextInput } from "./OrderAttributeTextInput";
const componentsMap = new Map(Object.entries({
    [IOrderInputTypeEnum.Text]: (props) => _jsx(OrderAttributeTextInput, { ...props }),
    [IOrderInputTypeEnum.Checkbox]: (props) => _jsx(OrderAttributeCheckbox, { ...props }),
}));
export const OrderAttributes = ({ target }) => {
    const getUserProfileQuery = useGetProfile();
    const orderAttributes = useSelector((state) => selectOrderAttributesByTarget(state, target));
    if (getUserProfileQuery.isLoading) {
        return null;
    }
    return (_jsx(_Fragment, { children: orderAttributes.map((orderAttribute) => {
            if (getUserProfileQuery.data?.extra && Object.hasOwn(getUserProfileQuery.data?.extra, orderAttribute.code)) {
                return null;
            }
            return componentsMap.get(orderAttribute.input_type)?.({ orderAttribute, key: orderAttribute.code });
        }) }));
};
//# sourceMappingURL=OrderAttributes.js.map